import type { ReportBundle, ReportEntry } from '../../../shared/types.js';
import { scopeLabel } from '../../lib/scope.js';

function proof(entry: ReportEntry): string {
  return entry.evidence.map((e) => e.label ?? e.url ?? e.kind).join(', ');
}

export function OnePager({ report }: { report: ReportBundle }) {
  return (
    <div className="onepager">
      <div className="op-head">
        <h3>Levelling case</h3>
        <span className="muted">
          Assigned {report.config.assigned_level} · arguing to {report.config.target_level} ·{' '}
          {report.summary.dimensions_meeting_target}/{report.summary.dimensions_total} dimensions ≥ target
        </span>
      </div>
      {report.dimensions.map((d) => (
        <div key={d.id} className={`op-row${d.strongest ? '' : ' hole'}`}>
          <div className="op-dim">
            {d.name}
            {d.evidenced && <span className="badge evidenced">Evidenced {d.evidenced.level}</span>}
          </div>
          {d.strongest && d.evidenced ? (
            <div className="op-body">
              <span className="op-acc">{d.strongest.title}</span>{' '}
              {d.strongest.scope === 'stretch' && <span className="badge scope">{scopeLabel(d.strongest.scope)}</span>}
              <p className="op-desc">"{d.evidenced.descriptor}"</p>
              {d.strongest.impact && <span className="op-impact">↳ {d.strongest.impact}</span>}
              {proof(d.strongest) && <span className="op-proof"> · {proof(d.strongest)}</span>}
            </div>
          ) : (
            <div className="op-body muted">No confirmed evidence this period — log before review.</div>
          )}
        </div>
      ))}
    </div>
  );
}
